import { Table, Container, Button, Row, Col, Input } from 'reactstrap';
import { NumberWithCommas } from "../../share/NumberWithCommas";
import React, { useEffect, useState } from 'react';
import { RiFileExcel2Line } from 'react-icons/ri'
import { AiOutlineFilePdf } from 'react-icons/ai'
import './Reports.css'
// import pdfFonts from "pdfmake/build/vfs_fonts";
// import pdfMake from "pdfmake/build/pdfmake";
// pdfMake.vfs = pdfFonts.pdfMake.vfs;

export function Report193() {
    // pdfMake.fonts = {
    //     THSarabunNew: {
    //         normal: 'THSarabunNew.ttf',
    //         bold: 'THSarabunNew Bold.ttf',
    //         italics: 'THSarabunNew Italic.ttf',
    //         bolditalics: 'THSarabunNewn BoldItalic.ttf'
    //     },
    //     Roboto: {
    //         normal: 'Roboto-Regular.ttf',
    //         bold: 'Roboto-Medium.ttf',
    //         italics: 'Roboto-Italic.ttf',
    //         bolditalics: 'Roboto-MediumItalic.ttf'
    //     }
    // }
    
    const [Borrow193data, setBorrow193data] = useState([]);

    // async function GetV193() {
    //     const response193 = await fetch("/api/BorrowReports/getV193")
    //     const Borrow193data = await response193.json()
    //     setBorrow193data(Borrow193data.dataenum);
    //     console.log(Borrow193data)
    // }
    const [thYearSelected, setThYearSelected] = React.useState(new Date().getFullYear() + 543)
    // console.log("thYearSelected",thYearSelected)
    // const [date193data, setdate193data] = useState([{ updateDate: '' }]); //ใช้ปะเนี้ยยย

    async function GetV193() {
        const formData = new FormData();
        formData.append("thYear", thYearSelected);
        const res = await fetch("/api/BorrowReports/getV193", {
            method: 'POST',
            body: formData
        })
        const data = await res.json()
        setBorrow193data(data.dataenum)

    }

    // async function getdate() {
    //     const resdate193 = await fetch("/api/BorrowReports/getdateV193")
    //     const date193data = await resdate193.json();
    //     setdate193data(date193data.dataenum)
    //     console.log("date193data",date193data)
    // }

    const [Re193yeardata, setRe193yeardata] = React.useState([]);
    async function getR193year() {
        const res = await fetch("/api/BorrowReports/getyear193")
        const Re193yeardata = await res.json()
        setRe193yeardata(Re193yeardata.dataenum)
        // console.log(Re193yeardata)
    }


    
    // const PrintPDF = () => {
    //     var tablebody = [[{ text: 'เดือน', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ถึงเวลากำหนดชำระเงิน (บริษัท)', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ชำระคืน (บริษัท)', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ค้างชำระ (บริษัท)', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ยอดเงินชำระคืนที่ต้องได้รับ', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'รับชำระหนี้', colSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, {}, {}, { text: 'ร้อยละ', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'เงินต้นค้างชำระ ณ เดือน', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ดอกเบี้ยผิดนัด', rowSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }],
    //     [{}, {}, {}, {}, {}, { text: 'เงินต้น', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'ดอกเบี้ย', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'รวม', fillColor: '#cccccc', bold: true, alignment: 'center' }, {}, {}, {}],
    //     [{ text: 'ปีงบประมาณ ' +  thYearSelected, colSpan: 11, fillColor: '#cccccc', bold: true, alignment: 'left' }, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
    //     [{ text: 'ยอดยกมาปีงบประมาณ ' +  thYearSelected, colSpan: 4, fillColor: '#cccccc', bold: true, alignment: 'left' }, { text: '', fillColor: '#cccccc' }, { text: '', fillColor: '#cccccc' }, { text: '', fillColor: '#cccccc' }, { text: '', fillColor: '#cccccc' }, { text: '', fillColor: '#cccccc' }, { text: '', fillColor: '#cccccc' }, { text: '', fillColor: '#cccccc' }, { text: '', fillColor: '#cccccc' }, { text: '', fillColor: '#cccccc' }, { text: '', fillColor: '#cccccc' }]];
    //     Borrow193data.forEach(function (item) {
    //         var rowdata = [{ text: item.monthBroughtForwardTh + thYearSelected, alignment: 'left' }, { text: item.dueDetComp, alignment: 'cenrightter' }, { text: item.payment, alignment: 'right' }, { text: item.overdueAmt, alignment: 'right' }, { text: (NumberWithCommas(item.repaymentRequired)), alignment: 'right' }, { text: (NumberWithCommas(item.principle)), alignment: 'right' }, { text: (NumberWithCommas(item.interest)), alignment: 'right' }, { text: (NumberWithCommas(item.total)), alignment: 'right' }, { text: item.percent, alignment: 'right' }, { text: (NumberWithCommas(item.overduePrincipal)), alignment: 'right' }, { text: (NumberWithCommas(item.interestDefault)), alignment: 'right' }]
    //         tablebody.push(rowdata);
    //     });
    //     var docDefinition = {
    //         pageOrientation: 'landscape',
    //         content: [
    //             { text: 'สรุปข้อมูลการชำระหนี้และหนี้ค้างชำระ', bold: true, alignment: 'center', fontSize: 18 },
    //             { text: 'ประจำปีงบประมาณ พ.ศ. ' + thYearSelected, bold: true, alignment: 'center', fontSize: 16 },
    //             {
    //                 table: {
    //                     widths: ['*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
    //                     body: tablebody
    //                 },
    //             }, { text: 'ข้อมูล ณ วันที่ ' + date193data.updateDate, alignment: 'right' },
    //         ],

    //         defaultStyle: {
    //             font: 'THSarabunNew'
    //         }

    //     }
    //     pdfMake.createPdf(docDefinition).download('R193')
    // }

    useEffect(() => {
        GetV193()
        getR193year()
    }, [thYearSelected])

    let sum1 = Borrow193data.reduce(function (prev, current) {
        return prev + +current.dueSetComp
    }, 0);
    let sum2 = Borrow193data.reduce(function (prev, current) {
        return prev + +current.payment
    }, 0);
    let sum3 = Borrow193data.reduce(function (prev, current) {
        return prev + +current.overdueAmt
    }, 0);
    let sum4 = Borrow193data.reduce(function (prev, current) {
        return prev + +current.repaymentRequired
    }, 0);
    let sum5 = Borrow193data.reduce(function (prev, current) {
        return prev + +current.principle
    }, 0);
    let sum6 = Borrow193data.reduce(function (prev, current) {
       return prev + +current.interest
    }, 0);
    let sum7 = Borrow193data.reduce(function (prev, current) {
        return prev + +current.total
    }, 0);
    // let sum8 = Borrow193data.reduce(function (prev, current) {
    //     return prev + +current.percent
    // }, 0);
    let sum9 = Borrow193data.reduce(function (prev, current) {
       return prev + +current.overduePrincipal
    }, 0);
    let sum10 = Borrow193data.reduce(function (prev, current) {
        return prev + +current.interestDefault
    }, 0);
    return (
        <Container>
            <div>
                {/* <div style={{ display: 'flex', paddingBottom: '20px', justifyContent: 'center' }}>
                    <h3 className='text-center' style={{ lineHeight: 'inherit' }}>
                        ประจำปีงบประมาณ พ.ศ.  
                    </h3>
                    <Input
                        style={{ borderColor: "#FFFFFF", width: "10%", paddingTop: '0px', fontSize: '1.75rem' }}
                        id="thYear"
                        name="thYear"
                        type="select"
                        value={thYearSelected}
                        onChange={(e) => {
                            setThYearSelected(e.target.value)
                        }}
                    >
                        {Re193yeardata.map((item, i) => (
                            <option value={item.yearTh}>
                                {item.yearTh}
                            </option>

                        ))}
                    </Input>
                </div> */}
                <div className='d-flex justify-content-center align-items-center'>
                    <span className='header-select-year mx-3'>ประจำปีงบประมาณ พ.ศ.</span>
                    <Input
                        // className='report-select-one-year'
                        className="rounded-pill input-color w-25 text-center"
                        id="thYear"
                        name="thYear"
                        type="select"
                        defaultValue={thYearSelected}
                        value={thYearSelected}
                        onChange={(e) => {
                            if(e.target.value === "กรุณาเลือก"){
                                return;
                            } else {
                                setThYearSelected(e.target.value)
                            }
                        }}
                    >
                        <option defaultValue={"กรุณาเลือก"}>กรุณาเลือก</option>
                        {Re193yeardata?.map((item, i) => (
                            <option className='option-style' value={item.yearTh}>
                                {item.yearTh}
                            </option>

                        ))}
                     
                    </Input>
                </div>
                <Row className='my-3'>
                    <Col className='d-flex justify-content-end'>
                        <Button className="btn border border-1 mx-1 btn-green" href={`api/BorrowReports/xlsxV193?thYear=${thYearSelected}`} download><RiFileExcel2Line/> Export Excel</Button>
                        <Button className="btn border border-1 mx-1 btn-red" href={`api/BorrowReports/pdfR193?thYear=${thYearSelected}`} download><AiOutlineFilePdf/> Export PDF</Button>
                    </Col>
                </Row>

                <div className="report-wrapper">
                <Table className="styled-table text-center" bordered striped hover>
                    <thead className='styles-thead'>
                        <tr>
                            <th rowSpan="2" className='text-center'>
                                เดือน
                            </th>
                            <th rowSpan="2" className='text-center'>
                                ถึงเวลากำหนดชำระเงิน (บริษัท)
                            </th>
                            <th rowSpan="2" className='text-center'>
                                ชำระคืน (บริษัท)
                            </th>
                            <th rowSpan="2" className='text-center'>
                                ค้างชำระ (บริษัท)
                            </th>
                            <th rowSpan="2" className='text-center'>
                                ยอดเงินชำระคืนที่ต้องได้รับ
                            </th>
                            <th colSpan="3" className=' text-center'>
                                รับชำระหนี้
                            </th>
                            <th rowSpan="2" className='text-center'>
                                ร้อยละ
                            </th>
                            <th rowSpan="2" className='text-center'>
                                เงินต้นค้างชำระ
                            </th>
                            <th rowSpan="2" className='text-center'>
                                ดอกเบี้ยผิดนัด
                            </th>
                        </tr>
                        <tr>
                            <th className='text-center'>
                                เงินต้น
                            </th>
                            <th className='text-center'>
                                ดอกเบี้ย
                            </th>
                            <th className='text-center'>
                                รวม
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {Borrow193data.length > 0 ? (
                            <>
                                <tr>
                                    <th colSpan="11" className='text-start'>
                                        ปีงบประมาณ {thYearSelected}
                                    </th> 
                                </tr>
                                <tr> 
                                    <th colSpan="11" className='text-start'>
                                        ยอดยกมาปีงบประมาณ {thYearSelected}
                                    </th> 
                                </tr>
                            </>
                        ):null}
                        
                        {Borrow193data?.map((item, i) => (
                        <tr> 
                            <th scope="row" className='text-start'>
                                {item.monthBroughtForwardTh + ' ' + thYearSelected}
                            </th>
                            <td className='text-end'>
                                {item.dueSetComp}
                            </td>
                            <td className='text-end'>
                                {item.payment}
                            </td>
                            <td className='text-end'>
                                {item.overdueAmt}
                            </td>
                            <td className='text-end'>
                                {NumberWithCommas(item.repaymentRequired)}
                            </td>
                            <td className='text-end'>
                                {NumberWithCommas(item.principle)}
                            </td>
                            <td className='text-end'>
                                {NumberWithCommas(item.interest)}
                            </td>
                            <td className='text-end'>
                                {NumberWithCommas(item.total)}
                            </td>
                            <td className='text-end'>
                                {item.percent}%
                            </td>
                            <td className='text-end'>
                                {NumberWithCommas(item.overduePrincipal)}
                            </td>
                            <td className='text-end'>
                                {NumberWithCommas(item.interestDefault)}
                            </td>
                        
                        </tr> ))}
                    </tbody>
                    <tfoot>
                    {Borrow193data.length > 0 ? (
                        <tr>
                            <th scope="row">
                                รวมทั้งสิ้น
                            </th>
                            <td className='text-end'>
                                {sum1}
                            </td>
                            <td className='text-end'>
                                {sum2}
                            </td>
                            <td className='text-end'>
                                {sum3}
                            </td>
                            <td className='text-end'>
                                {NumberWithCommas(sum4)}
                            </td>
                            <td className='text-end'>
                                {NumberWithCommas(sum5)}
                            </td>
                            <td className='text-end'>
                                {NumberWithCommas(sum6)}
                            </td>
                            <td className='text-end'>
                                {NumberWithCommas(sum7)}
                            </td>
                            <td className='text-end'>
                                {/* {sum8} */} -
                            </td>
                            <td className='text-end'>
                                {NumberWithCommas(sum9)}
                            </td>
                            <td className='text-end'>
                                {NumberWithCommas(sum10)}
                            </td>
                        </tr>
                        ):(
                            <tr>
                                <td colSpan="14" rowSpan="6" className='text-center'>ไม่มีข้อมูลในระบบ</td>
                            </tr>
                        )}
                        
                    </tfoot>
                </Table>
                </div>

            </div>
        </Container>);


}




